/****************************************************
 * Module Name:  WolzaProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class WolzaProxy {

    static UploadWolzaExcel = (file, callback) => {
        restAPICall(
            Constants.WORKER_URL + `/upload/wolza`,
            "post",
            Constants.userToken,
            undefined,
            file,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}